import React from 'react';
import { connect } from 'react-redux';

// Components
import { Route } from 'react-router-dom';
import { Card } from 'antd';

const PrivateRoute = ({ isAuthenticated, component: Component, logout, ...rest }) =>
    isAuthenticated ? <Route {...rest} render={props => <Component {...props} logout={logout} />} /> : <Card loading />;

export default connect((state, ownProps) => ({
    ...ownProps,
    isAuthenticated: state.auth.get('isAuthorized')
}))(PrivateRoute);
